export const getFileLink = (link: string | undefined) => {
  if (!link) return "";

  link = link.replace(
    process.env.REACT_APP_API_URL?.replace("api", "uploads") ?? "",
    "",
  );
  return `/file${link}`;
};
